<a routerLink="/news-and-events/{{dataArticle?.category.slug}}/{{dataArticle?.seotitle}}" 
    class="card-article d-block w-100 border-type-1"
    [ngClass]="(type != 'Events')?'ver-1': 'ver-2'"
    [style.height]="height">
    <div class="ver-1 h-100" *ngIf="type != 'Events'">
        <div class="bg-artic w-100" 
            [ngClass]="{'theres-img': dataArticle?.picture}"
            [ngStyle]="{'background-image' : 'url('+ apiAsset + dataArticle?.picture +')'}">
        </div>
        <div class="warp h-100">
            <div class="d-flex justify-content-between">
                <p class="date mb-0">{{ dataArticle?.published_at | date:'EEEE dd/MM/yyyy' }}</p>
                <p class="artic-cat">{{ dataArticle?.category.title }}</p>
            </div>
            <div class="title">
                <p>{{ dataArticle?.subtitle }}</p>
                <h5 class="mb-0">{{ globalService.trimString2(dataArticle?.title, 60) }}</h5>
            </div>
        </div>
    </div>
    <div class="ver-2" *ngIf="type == 'Events'">
        <div class="text-right bg-event" [ngStyle]="{'background-image' : 'url('+ apiAsset + dataArticle?.picture +')'}"></div>
        <p class="artic-cat">{{ dataArticle?.category.title }}</p>
        <div class="warp d-flex pr-3">
            <div class="w-date text-center px-2">
                <h2 class="day mb-0">{{ dataArticle?.published_at | date:'dd' }}</h2>
                <span class="month d-xl-block d-none">{{ dataArticle?.published_at | date:'MMMM yyyy' }}</span>
                <span class="month d-xl-none d-block">{{ dataArticle?.published_at | date:'MMM yyyy' }}</span>
            </div>
            <div class="title pl-3">
                <p class="mb-1">{{ dataArticle?.subtitle }}</p>
                <h5 class="mb-0">{{ globalService.trimString2(dataArticle?.title, 60) }}</h5>
            </div>
        </div>
    </div>
</a>
